import React, { useEffect } from "react";
import StartAudioContext from "startaudiocontext";

import Tone from "../lib/tone";

type SongContextProps = {
  isPlaying: boolean;
  exporting: boolean;
  recorder?: any;
};

export const SongContext = React.createContext<SongContextProps>({
  isPlaying: false,
  exporting: false,
});

export type SongProps = {
  exporting: boolean;
  isPlaying?: boolean;
  bpm?: number;
  swing?: number;
  subdivision?: string;
  swingSubdivision?: string;
  volume?: number;
  isMuted?: boolean;
  children?: React.ReactNode;
  recorder?: any;
  setContextStarted: React.Dispatch<React.SetStateAction<boolean>>;
};

const Song: React.FC<SongProps> = ({
  isPlaying = false,
  bpm = 90,
  // subdivision = '4n',
  swing = 0,
  swingSubdivision = "8n",
  volume = 0,
  isMuted = false,
  recorder,
  exporting,
  children,
  setContextStarted,
}) => {
  useEffect(() => {
    document.body && document.body.addEventListener(
      "click",
      () => {
        // iOS Web Audio API requires this library.
        // console.log("Context = ", Tone.context)
        StartAudioContext(Tone.context).then(() => {
          setContextStarted(true);
          console.log("Audio context started");
        });
      },
      {
        once: true,
      }
    );
  }, [setContextStarted]);

  useEffect(() => {
    Tone.Transport.bpm.value = bpm;
    Tone.Transport.swing = swing;
    Tone.Transport.swingSubdivision = swingSubdivision;
  }, [bpm, swing, swingSubdivision]);

  useEffect(() => {
    if (isPlaying || exporting) {
      // Hack to get Tone to NOT use same settings from another instance
      Tone.Transport.bpm.value = bpm;
      Tone.Transport.swing = swing;
      Tone.Transport.swingSubdivision = swingSubdivision;

      Tone.Transport.start();
    } else {
      Tone.Transport.stop();
    }
    /* eslint-disable-next-line */
  }, [isPlaying, exporting]);

  useEffect(() => {
    Tone.Master.volume.value = volume;
  }, [volume]);

  useEffect(() => {
    Tone.Master.mute = volume === 0 ? true : isMuted;
  }, [isMuted, volume]);

  if (typeof window === "undefined") {
    return null;
  }
  return (
    <SongContext.Provider
      value={{
        isPlaying,
        exporting,
        recorder,
      }}
    >
      {children}
    </SongContext.Provider>
  );
};

export default Song;
